import {
  ENDPOINT_ROOT,
  ENDPOINT_USERS_RENEW_PASSWORD_SEND_LINK,
} from '@/common/constants';
import axiosPublic from '@/common/interceptors/axios.PublicInterceptor';

const postRenewPasswordSendLink = (payload) =>
  axiosPublic
    .post(
      `${ENDPOINT_ROOT}/${ENDPOINT_USERS_RENEW_PASSWORD_SEND_LINK}`,
      payload,
    )
    .then(({ data }) => data);

export default postRenewPasswordSendLink;
